import React, { useContext } from 'react';
import { isMobile } from 'react-device-detect';
import { Text, View } from '@coinscrap/webapp-core';

import { MainModal } from '../../../components/MainModal/MainModal';
import { SmallButton } from '../../../components/SmallButton/SmallButton';
import { CONFIG } from '../../../config/config';
import { AgentContext } from '../../../contexts/agent';

export const useTarificationError = (
	e,
	setTrigger,
	openModal,
	navigateTo,
	isDebug,
	clearSession,
	agent,
) => {
	const asyncClearSession = async (close) => {
		close();
		CONFIG.routing.koReset.koReset(navigateTo, agent.identifier);
	};

	const errorMessage = e?.safeMessage?.toString();
	const errorArray = errorMessage.split('|');
	console.log('💢 errorArray', errorArray);

	let erroresConocidos = [];

	let mostrarReintentar = false;
	let mostrarReiniciar = false;
	let mostrarRevisarDatos = false;
	let mostrarRevisarCapital = false;
	let mostrarContactar = false;

	if (errorMessage.includes('ET1DRWT9-000000015')) {
		erroresConocidos.push('DISTINTO_DNI');
		mostrarReiniciar = true;
	}
	if (errorMessage.includes('No tiene modalidades contratables')) {
		erroresConocidos.push('SIN_MODALIDADES_CONTRATABLES');
		mostrarRevisarCapital = true;
		mostrarContactar = true;
	}
	if (errorMessage.includes('WSEV0001-000002002')) {
		erroresConocidos.push('XML_ENVIADO_INVALIDO');
		mostrarRevisarDatos = true;
		mostrarReiniciar = true;
		mostrarContactar = true;
	}
	if (
		errorMessage.includes('CORE-TR') ||
		errorMessage.includes('TR-04') ||
		errorMessage.includes('Invalid target status')
	) {
		erroresConocidos.push('INVALID_TARGET_STATUS');
		mostrarReiniciar = true;
		mostrarContactar = true;
	}
	const totalErrors = errorArray.length - 2;

	openModal(
		(close) => (
			<MainModal type="error">
				<Text headingPrimarySt errorSt>
					{totalErrors > 1
						? 'Se han encontrado varios errores'
						: erroresConocidos.includes('XML_ENVIADO_INVALIDO')
						? 'Ha ocurrido un error. Reinicie el proceso por favor.'
						: erroresConocidos.includes('DISTINTO_DNI')
						? 'No se puede cambiar el documento de identidad una vez iniciado el proceso'
						: erroresConocidos.includes('INVALID_TARGET_STATUS')
						? 'No puedes volver a este punto del proceso'
						: erroresConocidos.includes('SIN_MODALIDADES_CONTRATABLES')
						? 'La prima mínima es inferior a las normas de contratación, revisar capital'
						: 'Ha ocurrido un error'}
				</Text>

				{isDebug ? (
					<Text errorSt smSt style={{ marginTop: 10 }}>
						👷‍♂️ DEBUG ERROR
					</Text>
				) : null}

				{isDebug && totalErrors > 1 ? (
					errorArray.map((error, index) => {
						if (index === 0 || index === errorArray.length - 1) {
							return null;
						}
						return (
							<Text errorSt smSt>
								{error?.toString()}
							</Text>
						);
					})
				) : isDebug ? (
					<Text errorSt smSt>
						{errorArray[errorArray?.length - 1 ?? 0]?.toString()}
					</Text>
				) : null}
				<View colRowSt style={{ marginTop: 20 }}>
					{mostrarRevisarCapital && (
						<SmallButton
							onClick={() => {
								CONFIG.routing.activateProduct.koReviewCapital(navigateTo);
								close();
							}}
						>
							Modificar capital
						</SmallButton>
					)}
					{mostrarRevisarDatos && (
						<SmallButton
							onClick={() => {
								CONFIG.routing.activateProduct.koReviewData(navigateTo);
								close();
							}}
						>
							Revisar datos
						</SmallButton>
					)}
					{mostrarReiniciar && (
						<SmallButton onClick={() => asyncClearSession(close)}>
							Reiniciar proceso
						</SmallButton>
					)}
					{mostrarReintentar && (
						<SmallButton
							onClick={() => {
								setTrigger((t) => t + 1);
								close();
							}}
						>
							Reintentar
						</SmallButton>
					)}
					{mostrarContactar && (
						<SmallButton
							onClick={() => {
								CONFIG.routing.simulation.contact(navigateTo);
								close();
							}}
						>
							Contactar
						</SmallButton>
					)}
				</View>
			</MainModal>
		),
		{
			disableClickAway: true,
			closeButton: false,
			modalClass: isMobile ? 'modal-xl' : 'modal-main',
			key: 'modal-TarificationError-KO',
		},
	);
};
